
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("1R1pH"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("1R1pH", function(module, exports) {

let $159bd65f1c554000$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $159bd65f1c554000$var$load("h3ABO"),
    $159bd65f1c554000$var$load("kIM9N"),
    $159bd65f1c554000$var$load("aNhGE"),
    $159bd65f1c554000$var$load("djHM5"),
    $159bd65f1c554000$var$load("eJQji"),
    $159bd65f1c554000$var$load("2YffH"),
    $159bd65f1c554000$var$load("9slUK"),
    $159bd65f1c554000$var$load("6mHrv"),
    $159bd65f1c554000$var$load("awWN9"),
    $159bd65f1c554000$var$load("9CYct"),
    $159bd65f1c554000$var$load("gQllS"),
    $159bd65f1c554000$var$load("bxrdv"),
    $159bd65f1c554000$var$load("hZtKG"),
    $159bd65f1c554000$var$load("iNmaF"),
    $159bd65f1c554000$var$load("lVO3w"),
    $159bd65f1c554000$var$load("hyzoX"),
    $159bd65f1c554000$var$load("h9Ed7"),
    $159bd65f1c554000$var$load("eBRUf"),
    $159bd65f1c554000$var$load("kbRvk"),
    $159bd65f1c554000$var$load("9Vh0G"),
    $159bd65f1c554000$var$load("hBIgN"),
    $159bd65f1c554000$var$load("cD6Zr"),
    $159bd65f1c554000$var$load("9wzNh"),
    $159bd65f1c554000$var$load("8YSo7"),
    $159bd65f1c554000$var$load("3Zfzp"),
    $159bd65f1c554000$var$load("9ldRJ"),
    $159bd65f1c554000$var$load("50ame"),
    $159bd65f1c554000$var$load("e7ZUf"),
    $159bd65f1c554000$var$load("gL8bn"),
    $159bd65f1c554000$var$load("ebWFc"),
    $159bd65f1c554000$var$load("6iz6l"),
    $159bd65f1c554000$var$load("4SCW2"),
    $159bd65f1c554000$var$load("8bXcu"),
    $159bd65f1c554000$var$load("1YiFu"),
    $159bd65f1c554000$var$load("hv4mn"),
    $159bd65f1c554000$var$load("Wowvf"),
    $159bd65f1c554000$var$load("dek7I"),
    $159bd65f1c554000$var$load("3SmkN"),
    $159bd65f1c554000$var$load("dYtBN"),
    $159bd65f1c554000$var$load("kNV5Y"),
    $159bd65f1c554000$var$load("6wr18"),
    $159bd65f1c554000$var$load("kjZZD"),
    $159bd65f1c554000$var$load("2zxmz"),
    $159bd65f1c554000$var$load("7269o"),
    $159bd65f1c554000$var$load("3JSgG"),
    $159bd65f1c554000$var$load("37ldp"),
    $159bd65f1c554000$var$load("ffEVr"),
    $159bd65f1c554000$var$load("dRpV3"),
    $159bd65f1c554000$var$load("dTsOE"),
    $159bd65f1c554000$var$load("hhss7"),
    $159bd65f1c554000$var$load("jYUNl"),
    $159bd65f1c554000$var$load("foy8I"),
    $159bd65f1c554000$var$load("jY21r"),
    $159bd65f1c554000$var$load("dP7ao"),
    $159bd65f1c554000$var$load("hogcU"),
    $159bd65f1c554000$var$load("i8eeg"),
    $159bd65f1c554000$var$load("iFdoJ"),
    $159bd65f1c554000$var$load("7EorR"),
    $159bd65f1c554000$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.fe2feac0.js.map
